module.exports = __webpack_public_path__ + "pingpong.png?855afd10274c7eafbf9fbf72a364ddac";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/pingpong.png
// module id = 231
// module chunks = 0